import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DynamicListArea,BulkEdit,LoadGraphic,Step} from '../components/Common';
import u from '../utilities/Utilities';


export default class PointHistoryList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Reward History",
        permission:"combined",          //Accepts combined permission module as well
        combinedField:"pointHistory",   //Used when permission exists in a combined field
        url:"/point-history-list",

        /**** Action Setup ****/
        addType:0,
        deleteURL:"/api/delete-point-history-entries",
        spreadsheetURL:"/api/generate-point-history-spreadsheet",
        overviewURL:"/api/get-all-point-history-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"point-history-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        })
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index} 
                                          index={index} 
                                          content={content} 
                                          onChange={onChange} 
                                          onContentChange={onContentChange} 
                                          registerReference={registerRef} 
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
    };

    render=()=>{
        const {content,settings,permissions} = this.props;
        const canEdit= (permissions.update==2);

        return (
            <div style={{textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={this.state.step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel} 
                                    permission={settings.permission} 
                                    content={content} 
                                    onChange={this.props.onChange} 
                                    index={this.props.index}
                                    />
                </Step>
            </div>
        )
    }
}

export class MiniPointHistoryList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Reward History",
        permission:"combined",          //Accepts combined permission module as well
        combinedField:"pointHistory",   //Used when permission exists in a combined field
        url:"/point-history-list",

        /**** Action Setup ****/
        addType:0,
        deleteURL:"/api/delete-point-history-entries",
        spreadsheetURL:"/api/generate-point-history-spreadsheet",
        overviewURL:"/api/get-all-point-history-entries",

        /**** List Setup ****/
        listLabel:"point-history-list",
        orderByField:"createdOn",
        orderByType:"descending",
    };

    refresh=()=>{
        this.r['list'].refresh();
    }

    render=()=>{
        return(
            <MiniList ref={(ref)=>{this.r["list"]=ref}}
                      settings={this.settings}
                      tags={this.props.tags}
                      pageLength={this.props.pageLength}
                      orderByField={this.props.orderByField}
                      orderByType={this.props.orderByType}
                      />
        )
    }
}


